import React from 'react';
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Divider, Input, InputNumber, Row } from 'antd';

export default function Batches({ Form }) {
	return (
		<Form.List name='batches'>
			{(fields, { add, remove }) => (
				<>
					{fields.map(({ key, name }) => (
						<Row gutter={[16, 0]} key={key}>
							<Col sm={24} md={6}>
								<Form.Item label='Batch Name' name={[name, 'batchName']}>
									<Input placeholder='For e.g. Batch 1' autoFocus />
								</Form.Item>
							</Col>
							<Col sm={24} md={4}>
								<Form.Item label='Batch City' name={[name, 'batchCity']}>
									<Input style={{ width: '100%' }} placeholder='Batch Start Location' />
								</Form.Item>
							</Col>
							<Col sm={24} md={3}>
								<Form.Item label='Batch size' name={[name, 'batchSize']}>
									<InputNumber style={{ width: '100%' }} placeholder='10' />
								</Form.Item>
							</Col>
							<Col sm={24} md={7}>
								<Form.Item
									label='Start & End Date/Time'
									name={[name, 'batchStartEndDateTime']}
									rules={[
										{
											required: true,
											message: 'Batch Start & End Date/Time is required',
										},
									]}
								>
									<DatePicker.RangePicker showTime />
								</Form.Item>
							</Col>
							<Col sm={24} md={3}>
								<Form.Item label='Batch Days & Nights' name={[name, 'batchDaysNights']}>
									<Input placeholder='For e.g. 5 days 4 nights' />
								</Form.Item>
							</Col>
							<Col sm={24} md={1}>
								{fields.length > 1 ? (
									<Form.Item label='&nbsp;'>
										<Button icon={<CloseOutlined />} shape='circle' onClick={() => remove(name)} />
									</Form.Item>
								) : null}
							</Col>
							<Divider style={{ margin: 0, marginBottom: 16 }} />
						</Row>
					))}
					<Row gutter={[16, 0]}>
						<Col sm={24} md={6}>
							<Form.Item>
								<Button
									icon={<PlusOutlined />}
									type='primary'
									onClick={() => {
										add();
									}}
									style={{ width: '100%' }}
								>
									Add Batch
								</Button>
							</Form.Item>
						</Col>
					</Row>
				</>
			)}
		</Form.List>
	);
}
